var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-skeleton-loading",class:[`base-skeleton-loading--${_vm.variant}`, { 'is-animated': _vm.animated }]},_vm._l((_vm.layout),function(row,idx){return _c('div',{key:idx,staticClass:"base-skeleton-row",style:({ marginTop: idx ? '14px' : '0' })},_vm._l((row),function(block,bIdx){return _c('div',{key:bIdx,staticClass:"base-skeleton-block",class:block.cls,style:({
        width: block.w,
        height: `${block.h}px`,
      })})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }